/**
 * Muted Animus theme presets. CSS variables are applied on <html data-theme="...">.
 */
export const THEME_STORAGE_KEY = 'zemaxi-theme';

export const THEMES = [
  {
    id: 'original',
    label: 'ZE ORIGINAL',
    swatch: '#6b5b8a',
    vars: {
      '--primary-bg': '#0e141c',
      '--secondary-bg': '#121a24',
      '--tertiary-bg': '#1a2332',
      '--surface-border': 'rgba(122, 107, 150, 0.22)',
      '--purple-accent': '#6b5b8a',
      '--purple-muted': '#4a4060',
      '--accent': '#6b5b8a',
      '--blue-accent': '#6b5b8a',
      '--text-mono': '#a89bc4',
      '--accent-rgb': '107, 91, 138',
      '--accent-muted-rgb': '74, 64, 96',
      '--live-rgb': '122, 168, 138',
    },
  },
  {
    id: 'navy',
    label: 'Deepest Lore',
    swatch: '#4a6282',
    vars: {
      '--primary-bg': '#0c1218',
      '--secondary-bg': '#101820',
      '--tertiary-bg': '#162030',
      '--surface-border': 'rgba(90, 118, 154, 0.24)',
      '--purple-accent': '#5a7a9e',
      '--purple-muted': '#3d5268',
      '--accent': '#5a7a9e',
      '--blue-accent': '#5a7a9e',
      '--text-mono': '#9eb4cc',
      '--accent-rgb': '90, 122, 158',
      '--accent-muted-rgb': '61, 82, 104',
      '--live-rgb': '122, 168, 138',
    },
  },
  {
    id: 'ocean',
    label: 'Wet Floor Sign',
    swatch: '#4d7a8a',
    vars: {
      '--primary-bg': '#0b1318',
      '--secondary-bg': '#101a22',
      '--tertiary-bg': '#152430',
      '--surface-border': 'rgba(82, 128, 148, 0.24)',
      '--purple-accent': '#5a8a9a',
      '--purple-muted': '#3d5a68',
      '--accent': '#5a8a9a',
      '--blue-accent': '#5a8a9a',
      '--text-mono': '#9ec4d4',
      '--accent-rgb': '90, 138, 154',
      '--accent-muted-rgb': '61, 90, 104',
      '--live-rgb': '122, 168, 138',
    },
  },
  {
    id: 'teal',
    label: 'Teal Me More',
    swatch: '#4a8a82',
    vars: {
      '--primary-bg': '#0b1416',
      '--secondary-bg': '#101c1e',
      '--tertiary-bg': '#15282a',
      '--surface-border': 'rgba(82, 148, 138, 0.24)',
      '--purple-accent': '#5a9a8e',
      '--purple-muted': '#3d6860',
      '--accent': '#5a9a8e',
      '--blue-accent': '#5a9a8e',
      '--text-mono': '#9ed4c8',
      '--accent-rgb': '90, 154, 142',
      '--accent-muted-rgb': '61, 104, 96',
      '--live-rgb': '122, 168, 138',
    },
  },
  {
    id: 'forest',
    label: 'Touch Grass',
    swatch: '#5a7a5a',
    vars: {
      '--primary-bg': '#0e1410',
      '--secondary-bg': '#121a14',
      '--tertiary-bg': '#1a2820',
      '--surface-border': 'rgba(106, 148, 106, 0.22)',
      '--purple-accent': '#6a946a',
      '--purple-muted': '#4a684a',
      '--accent': '#6a946a',
      '--blue-accent': '#6a946a',
      '--text-mono': '#b4d4b4',
      '--accent-rgb': '106, 148, 106',
      '--accent-muted-rgb': '74, 104, 74',
      '--live-rgb': '122, 168, 138',
    },
  },
  {
    id: 'sage',
    label: 'Salad Dressing',
    swatch: '#6a8a72',
    vars: {
      '--primary-bg': '#101412',
      '--secondary-bg': '#141c18',
      '--tertiary-bg': '#1c2822',
      '--surface-border': 'rgba(122, 154, 130, 0.22)',
      '--purple-accent': '#7a9a82',
      '--purple-muted': '#566a5c',
      '--accent': '#7a9a82',
      '--blue-accent': '#7a9a82',
      '--text-mono': '#c4dcc8',
      '--accent-rgb': '122, 154, 130',
      '--accent-muted-rgb': '86, 106, 92',
      '--live-rgb': '122, 168, 138',
    },
  },
  {
    id: 'crimson',
    label: 'Panic Button',
    swatch: '#8a5a5a',
    vars: {
      '--primary-bg': '#141010',
      '--secondary-bg': '#1a1414',
      '--tertiary-bg': '#281c1c',
      '--surface-border': 'rgba(154, 106, 106, 0.24)',
      '--purple-accent': '#9a6a6a',
      '--purple-muted': '#684a4a',
      '--accent': '#9a6a6a',
      '--blue-accent': '#9a6a6a',
      '--text-mono': '#d4b4b4',
      '--accent-rgb': '154, 106, 106',
      '--accent-muted-rgb': '104, 74, 74',
      '--live-rgb': '168, 138, 122',
    },
  },
  {
    id: 'rust',
    label: 'Rusty Metadata',
    swatch: '#8a6a52',
    vars: {
      '--primary-bg': '#141210',
      '--secondary-bg': '#1a1814',
      '--tertiary-bg': '#28221c',
      '--surface-border': 'rgba(154, 122, 90, 0.24)',
      '--purple-accent': '#9a7a5a',
      '--purple-muted': '#685242',
      '--accent': '#9a7a5a',
      '--blue-accent': '#9a7a5a',
      '--text-mono': '#d4c4b4',
      '--accent-rgb': '154, 122, 90',
      '--accent-muted-rgb': '104, 82, 66',
      '--live-rgb': '168, 148, 122',
    },
  },
  {
    id: 'gold',
    label: 'Golden Retriever',
    swatch: '#9a8a62',
    vars: {
      '--primary-bg': '#141410',
      '--secondary-bg': '#1a1a14',
      '--tertiary-bg': '#28241c',
      '--surface-border': 'rgba(168, 148, 106, 0.24)',
      '--purple-accent': '#b8a06a',
      '--purple-muted': '#7a6a4a',
      '--accent': '#b8a06a',
      '--blue-accent': '#b8a06a',
      '--text-mono': '#e4d4b4',
      '--accent-rgb': '184, 160, 106',
      '--accent-muted-rgb': '122, 106, 74',
      '--live-rgb': '168, 158, 122',
    },
  },
  {
    id: 'honey',
    label: 'Honey, No',
    swatch: '#a89462',
    vars: {
      '--primary-bg': '#141412',
      '--secondary-bg': '#1c1a16',
      '--tertiary-bg': '#2a261e',
      '--surface-border': 'rgba(184, 160, 106, 0.24)',
      '--purple-accent': '#c4b07a',
      '--purple-muted': '#8a7a52',
      '--accent': '#c4b07a',
      '--blue-accent': '#c4b07a',
      '--text-mono': '#ece0c4',
      '--accent-rgb': '196, 176, 122',
      '--accent-muted-rgb': '138, 122, 82',
      '--live-rgb': '168, 158, 122',
    },
  },
  {
    id: 'blush',
    label: 'Pinkity Drinkity',
    swatch: '#d97aad',
    vars: {
      '--primary-bg': '#130f15',
      '--secondary-bg': '#1a1420',
      '--tertiary-bg': '#2a1c2a',
      '--surface-border': 'rgba(210, 110, 160, 0.28)',
      '--purple-accent': '#d97aad',
      '--purple-muted': '#8a4468',
      '--accent': '#d97aad',
      '--blue-accent': '#d97aad',
      '--text-mono': '#f4c4dc',
      '--accent-rgb': '217, 122, 173',
      '--accent-muted-rgb': '138, 68, 104',
      '--live-rgb': '188, 130, 168',
    },
  },
  {
    id: 'hurt-my-eyes',
    label: 'HURT MY EYES',
    swatch: '#f5f5f5',
    vars: {
      '--primary-bg': '#ffffff',
      '--secondary-bg': '#f7f7f7',
      '--tertiary-bg': '#ececec',
      '--surface-border': 'rgba(0, 0, 0, 0.14)',
      '--purple-accent': '#1a1a1a',
      '--purple-muted': '#c4c4c4',
      '--accent': '#262626',
      '--blue-accent': '#4a5568',
      '--text-color': '#0f0f0f',
      '--text-secondary': '#525252',
      '--text-mono': '#3a3a3a',
      '--accent-rgb': '38, 38, 38',
      '--accent-muted-rgb': '180, 180, 180',
      '--live-rgb': '52, 130, 92',
    },
  },
];

export const THEME_VAR_KEYS = Array.from(
  new Set(THEMES.flatMap((theme) => Object.keys(theme.vars))),
);

export const DEFAULT_THEME_ID = 'original';

export function getThemeById(id) {
  return THEMES.find((t) => t.id === id) ?? THEMES[0];
}

export function readStoredThemeId() {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === 'my-eyes-hurt') {
      return 'hurt-my-eyes';
    }
    if (stored === 'rose') {
      return 'blush';
    }
    if (stored && THEMES.some((t) => t.id === stored)) {
      return stored;
    }
  } catch {
    /* private mode / blocked storage */
  }
  return DEFAULT_THEME_ID;
}
